module.exports = __webpack_public_path__ + "img/dgjg-login.5cecdef8.svg";